import { logout } from '../../redux/actions/userAction'
import React, { useRef, useState } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { membershipNameType, PlanChangeLink, storyStep } from '../../utils/constant'
import { INTRODUCTION, SETTING } from 'routes/routeConstant'
// const searchplusIcon = <i className='fa fa-search-plus' />

interface HeaderProps {
  pathName?: any
  story?: any
  step?: any
  membership: any
  authToken: string
}

const HeaderOld: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { t } = useTranslation('common')
  // check access story view at last step
  const { membership } = props
  const navigate = useNavigate()
  const [isOpen, setOpen] = useState(false)

  let urlRedirectLogo = INTRODUCTION
  if (props.step === storyStep.Step1) {
    urlRedirectLogo = `/story/${props.story?.id}`
  }
  const refMenuMobile = useRef(document.createElement('div'))
  const onMenu = () => {
    if (refMenuMobile) {
      refMenuMobile.current.style.width =
        refMenuMobile.current.style.width === '0px' || !refMenuMobile.current.style.width ? '100%' : '0px'
    }
  }
  const onLogout = () => {
    logout(true)
  }
  // const onOpenAccount = () => {
  //   refMenuMobile.current.style.width = '0px'
  //   navigate(SETTING)
  // }
  const goToLastAccessStory = () => {
    refMenuMobile.current.style.width = '0px'
    navigate(urlRedirectLogo)
  }

  const isFree = membership?.name == membershipNameType.Free
  const isPremium = membership?.name == membershipNameType.Premium
  const isStandard = membership?.name == membershipNameType.Standard
  const isSchool = membership?.name == membershipNameType.School
  const isPro = membership?.name == membershipNameType.Pro
  const isTeacher = membership?.name == membershipNameType.Teacher
  const redirectToAccount = () => {
    navigate(PlanChangeLink)
  }

  return (
    <div className='navigation-container maayot-header'>
      <div className='container'>
        <div
          data-collapse='medium'
          data-animation='default'
          data-duration='400'
          id='navbar'
          role='banner'
          className='navbar-2 w-nav'
        >
          {false && props.authToken && (
            <a onClick={onMenu} className='button-menu-mobile menu-mobile-close nav-menu'>
              <i className='fa fa-bars'></i>
            </a>
          )}

          <Link to={urlRedirectLogo} className='w-nav-brand'>
            <img src='/images/Untitled-12.png' alt='' className='image-40' />
          </Link>
          <div className={isOpen ? 'overlay_div' : ''} onClick={() => setOpen(false)}></div>
          {/* {false && (
            <div className='font-changer-btn-div mob-icon-dropdown'>
              <div className='font-plus-dropdown' onClick={() => setOpen(!isOpen)}>
                <i className='fa fa-search-plus fa-icon-size' />
                {isOpen ? (
                  <div className='custom-dropdown-menu'>
                    <ul>
                      {FONT_SIZE_LIST.map((elm, index) => (
                        <li
                          key={index}
                          className={`${chineseWordFontSize?.storyContent === elm?.storyContent && 'active'}`}
                          onClick={() => onChangeFontSize(elm)}
                        >
                          {elm.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>
          )} */}
          <nav role='navigation' className='nav-menu-wrapper w-nav-menu'></nav>

          <div className='nav-menu-button-wrapper nav-menu-button-large'>
            <div className='nav-functions nav-menu'>
              {/* {!props?.authToken && (
                <div className='navbar-2 w-nav navbar-button-mobile overlay-content'>
                  <div className='div-block-4'>
                    <button onClick={onLogout} className='button-2 bg-gray-4 login w-button'>
                      Log In
                    </button>
                  </div>
                </div>
              )} */}
              {false && props.authToken && (
                <>
                  {/* <div className='m-flx'>
                    <div className='disable-correction-container' tabIndex={1}>
                      <div className={isOpen ? 'overlay_div' : ''} onClick={() => setOpen(false)}></div>
                      <div className='font-changer-btn-div'>
                        <div className='font-plus-dropdown' onClick={() => setOpen(!isOpen)}>
                          <i className='fa fa-search-plus fa-icon-size' />
                          {isOpen ? (
                            <div className='custom-dropdown-menu'>
                              <ul>
                                {FONT_SIZE_LIST.map((elm, index) => (
                                  <li
                                    key={index}
                                    className={`${chineseWordFontSize?.storyContent === elm?.storyContent && 'active'}`}
                                    // className={elm?.value === "18px" ? 'active' : ""}
                                    onClick={() => onChangeFontSize(elm)}
                                  >
                                    {elm.label}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div> */}

                  {/* <div className='div-block-4'> */}
                  <div className='m-flx'>
                    {(isPro || isStandard) && (
                      <>
                        {props.pathName !== '/correction' ? (
                          <>
                            {isStandard ? (
                              <>
                                <div className='disable-correction-container' tabIndex={1}>
                                  <span className='button-2 bg-gray-4 login w-button mr-10 disable-correction-btn'>
                                    <i
                                      className='fa fa-pencil'
                                      style={{ fontSize: '14px', marginRight: '5px', textDecoration: 'underline' }}
                                    ></i>
                                    {t('nav.corrections')}
                                  </span>

                                  <div className='disable-correction-tooltip Corrections-tooltip'>
                                    <div className='tooltiptextWriter' id='tooltiptextWriter'>
                                      <button className='tooltiptext-close'>
                                        <i className='fa fa-times' aria-hidden='true'></i>
                                      </button>
                                      {t('nav.correctionsProOnly')}
                                      <br></br>
                                      <a
                                        onClick={redirectToAccount}
                                        style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                      >
                                        {t('nav.upgradeNow')}
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <a href='/correction' className='button-2 bg-green-4 login w-button mr-10'>
                                <i
                                  className='fa fa-pencil'
                                  style={{ fontSize: '14px', marginRight: '5px', textDecoration: 'underline' }}
                                ></i>
                                {t('nav.corrections')}
                              </a>
                            )}
                          </>
                        ) : (
                          <a href='/introduction' className='button-2 bg-gray-4 login w-button mr-10'>
                            {t('nav.lesson')}
                          </a>
                        )}
                        {/* <a href='/streaks' className='button-2 bg-gray-4 login w-button mr-10'>
                          Streaks
                        </a> */}
                      </>
                    )}
                    {isFree && (
                      <>
                        <div className='disable-correction-container' tabIndex={2}>
                          <span className='button-2 bg-gray-4 login w-button mr-10 disable-correction-btn'>
                            <i
                              className='fa fa-pencil'
                              style={{ fontSize: '14px', marginRight: '5px', textDecoration: 'underline' }}
                            ></i>
                            {t('nav.corrections')}
                          </span>

                          <div className='disable-correction-tooltip Corrections-tooltip'>
                            <div className='tooltiptextWriter' id='tooltiptextWriter'>
                              <button className='tooltiptext-close'>
                                <i className='fa fa-times' aria-hidden='true'></i>
                              </button>
                              {t('nav.correctionsProOnly')}
                              <br></br>
                              <a onClick={redirectToAccount} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                                {t('nav.upgradeNow')}
                              </a>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {(isFree || isPremium || isStandard || isSchool || isPro) && props.pathName !== SETTING && (
                      <>
                        <a href={SETTING} className='button-2 bg-gray-4 login w-button mr-10'>
                          {t('nav.myAccount')}
                        </a>
                      </>
                    )}
                    {isTeacher && (
                      <a href='/dashboard' className='button-2 bg-gray-4 login w-button mr-10'>
                        {t('nav.dashboard')}
                      </a>
                    )}
                  </div>
                  <div className='div-block-4'>
                    <button onClick={onLogout} className='button-2 bg-gray-4 login w-button'>
                      {t('nav.logOut')}
                    </button>
                  </div>
                </>
              )}
            </div>
            <div className='menu-button-2 w-nav-button'></div>
          </div>
        </div>
        {/* Nav menu mobile */}
        <div className='nav-menu nav-menu-mobile overlay' ref={refMenuMobile}>
          <div className='nav-menu-mobile-content overlay-content'>
            <div className='navbar-2 w-nav'>
              <a onClick={onMenu} className='button-menu-mobile menu-mobile-close'>
                <i className='fa fa-times'></i>
              </a>
              <a onClick={goToLastAccessStory} className='w-nav-brand'>
                <img src='/images/Untitled-12.png' alt='' className='image-40' />
              </a>
            </div>

            {false && props.authToken && (
              <div className='navbar-2 w-nav navbar-button-mobile overlay-content'>
                {/* <div className='div-block-4'>
                  <div className='disable-correction-container' tabIndex={1}>
                    <div className={isOpen ? 'overlay_div' : ''} onClick={() => setOpen(false)}></div>
                    <div className='font-changer-btn-div mob-hide-div'>
                      <button className='button-2 bg-gray-4 login w-button mr-10' onClick={() => setOpen(!isOpen)}>
                        {searchplusIcon}
                        Aa
                      </button>

                      {isOpen ? (
                        <div className='custom-dropdown-menu'>
                          <ul>
                            {FONT_SIZE_LIST.map((elm, index) => (
                              <li
                                key={index}
                                className={`${chineseWordFontSize?.storyContent === elm?.storyContent && 'active'}`}
                                // className={elm?.value === "18px" ? 'active' : ""}
                                onClick={() => onChangeFontSize(elm)}
                              >
                                {elm.label}
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div> */}
                <div className='div-block-4'>
                  {(isPro || isStandard) &&
                    (props.pathName !== '/correction' ? (
                      <>
                        {isStandard ? (
                          <>
                            <div className='disable-correction-container' tabIndex={1}>
                              <div className='seemore-tooltip1mobile'>
                                <span className='button-2 bg-gray-4 login w-button mr-10 disable-correction-btn'>
                                  <i
                                    className='fa fa-pencil'
                                    style={{ fontSize: '14px', marginRight: '5px', textDecoration: 'underline' }}
                                  ></i>
                                  {t('nav.corrections')}
                                </span>

                                <div
                                  className='disable-correction-tooltip Corrections-tooltip'
                                  id='Corrections_tooltip'
                                >
                                  <div className='tooltiptextWriter' id='tooltiptextWriter'>
                                    <button className='tooltiptext-close'>
                                      <i className='fa fa-times' aria-hidden='true'></i>
                                    </button>
                                    {t('nav.correctionsProOnly')}
                                    <br></br>
                                    <a
                                      onClick={redirectToAccount}
                                      style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                    >
                                      {t('nav.upgradeNow')}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <a href='/correction' className='button-2 bg-green-4 login w-button mr-10'>
                            <i
                              className='fa fa-pencil'
                              style={{ fontSize: '14px', marginRight: '5px', textDecoration: 'underline' }}
                            ></i>
                            {t('nav.corrections')}
                          </a>
                        )}
                      </>
                    ) : (
                      <a href='/introduction' className='button-2 bg-gray-4 login w-button mr-10'>
                        {t('nav.lesson')}
                      </a>
                    ))}
                </div>
                <div className='div-block-4'>
                  {isFree && (
                    <>
                      <div className='disable-correction-container' tabIndex={1}>
                        <div className='seemore-tooltip1mobile'>
                          <span className='button-2 bg-gray-4 login w-button mr-10 disable-correction-btn'>
                            <i
                              className='fa fa-pencil'
                              style={{ fontSize: '14px', marginRight: '5px', textDecoration: 'underline' }}
                            ></i>
                            {t('nav.corrections')}
                          </span>

                          <div className='disable-correction-tooltip Corrections-tooltip' id='Corrections_tooltip'>
                            <div className='tooltiptextWriter' id='tooltiptextWriter'>
                              <button className='tooltiptext-close'>
                                <i className='fa fa-times' aria-hidden='true'></i>
                              </button>
                              {t('nav.correctionsProOnly')}
                              <br></br>
                              <a onClick={redirectToAccount} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                                {t('nav.upgradeNow')}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className='div-block-4'>
                  {(isFree || isPremium || isStandard || isSchool || isPro) && props.pathName !== SETTING && (
                    <a href={SETTING} className='button-2 bg-gray-4 login w-button mr-10'>
                      {t('nav.myAccount')}
                    </a>
                  )}
                </div>
                {isTeacher && (
                  <a href='/dashboard' className='button-2 bg-gray-4 login w-button mr-10'>
                    {t('nav.dashboard')}
                  </a>
                )}
                <div className='div-block-4'>
                  <button onClick={onLogout} className='button-2 bg-gray-4 login w-button'>
                    {t('nav.logOut')}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = (state: any) => ({
  authToken: state.user.authToken,
  membership: state.user.membership,
  step: state.story.currentStep,
  story: state.story.currentStory,
  chineseWordFontSize: state.dashboard.chineseWordFontSize,
})
export default connect(mapStateToProps)(HeaderOld)
